import { compare } from 'natural-orderby';

// Matches a dotted numeric label like "2.1", "2.11", "1.2.3" — the shape clause/test-spec
// labels use (e.g. SDA clause numbers). natural-orderby's compare() parses a *single-dot*
// numeric token (e.g. "2.1") as one decimal number, so "2.1" < "2.11" < "2.12" < "2.2" sorts
// as floats (2.1, 2.11, 2.12, 2.2) instead of the hierarchical order a reader expects
// (2.1, 2.2, 2.11, 2.12) — raytd/web QA test case 108.03, item 6. It gets multi-dot strings
// (like IP addresses) right already by comparing segments, so we only need to route the
// single-dot decimal case through the same segment-by-segment comparison.
const DOTTED_NUMERIC_LABEL = /^\d+(\.\d+)+$/;

function compareDottedNumericSegments(a: string, b: string): number {
    const segmentsA = a.split('.').map(Number);
    const segmentsB = b.split('.').map(Number);
    const maxLength = Math.max(segmentsA.length, segmentsB.length);

    for (let i = 0; i < maxLength; i++) {
        const segmentA = segmentsA[i] ?? -1;
        const segmentB = segmentsB[i] ?? -1;
        if (segmentA !== segmentB) return segmentA - segmentB;
    }

    return 0;
}

export function customCompare(a: string, b: string): number {
    const noPattern = /\(No .*\)/;
    const missingPattern = /\(Missing .*\)/;

    // If a or b is a "No" item, move it to the bottom
    const isANoItem = noPattern.test(a);
    const isBNoItem = noPattern.test(b);
    const isAMissingItem = missingPattern.test(a);
    const isBMissingItem = missingPattern.test(b);
    if (isAMissingItem && !isBMissingItem) return 1;  // a goes after b
    if (!isAMissingItem && isBMissingItem) return -1; // a goes before b
    if (isANoItem && !isBNoItem) return 1;  // a goes after b
    if (!isANoItem && isBNoItem) return -1; // a goes before b

    // Dotted numeric labels (clause numbers etc.) need hierarchical segment comparison —
    // see DOTTED_NUMERIC_LABEL above.
    if (DOTTED_NUMERIC_LABEL.test(a) && DOTTED_NUMERIC_LABEL.test(b)) {
        return compareDottedNumericSegments(a, b);
    }

    // Otherwise, apply natural sort
    return compare()(a, b);
  }